import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelRangeGnaEditComponent } from './model-range-gna-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
    declarations: [
        ModelRangeGnaEditComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        ButtonModule,
        ToastModule,
        DropdownModule
    ],
    exports: [
        ModelRangeGnaEditComponent
    ],
})
export class ModelRangeGnaEditModule { }
